import { Category } from "../types/event-response.type";

export function findCategoryUtil(categories: Category[], id: string | number): Category | null {
  const category_id = typeof id === 'string' ? parseInt(id, 10) : id;
  if (categories.length) {
    for (let i = 0; i < categories.length; i += 1) {
      if (categories[i].category_id === category_id) {
        return categories[i];
      }

      if (categories[i]?.subcategories?.length) {
        const child: any = findCategoryUtil(
          categories[i]?.subcategories ?? [],
          category_id
        );

        if (child !== null) {
          return child;
        }
      }
    }
  }

  return null;
}
